import { useMemo, useCallback } from "react";

export const NAV_LEVELS = {
    CONFIRM_DIALOG: 'confirmDialog',
    TERMS: 'terms',
    SIDE_PANEL: 'sidePanel',
    FILTERED: 'filtered',
    MAIN: 'main',
    CLOSED: 'closed',
};


export default function useBackNavigation({ states, actions }) {
    const {
        isOpen,
        showConfirmDialog,
        showTermsPopup,
        selectedEvent,
        showFiltered,
    } = states;

    const {
        closeSidePanel,
        closeFiltered,
        closeTerms,
        closeConfirmDialog,
        closeEPG,
        exitApp,
    } = actions;

    const currentLevel = useMemo(() => {
        if (showConfirmDialog) return NAV_LEVELS.CONFIRM_DIALOG;
        if (showTermsPopup) return NAV_LEVELS.TERMS;
        if (selectedEvent) return NAV_LEVELS.SIDE_PANEL;
        if (showFiltered) return NAV_LEVELS.FILTERED;
        if (isOpen) return NAV_LEVELS.MAIN;
        return NAV_LEVELS.CLOSED;
    }, [showConfirmDialog, showTermsPopup, selectedEvent, showFiltered, isOpen]);

    // Mapping levels to handlers
    const levelHandlers = useMemo(() => ({
        [NAV_LEVELS.CONFIRM_DIALOG]: closeConfirmDialog,
        [NAV_LEVELS.TERMS]: closeTerms,
        [NAV_LEVELS.SIDE_PANEL]: closeSidePanel,
        [NAV_LEVELS.FILTERED]: closeFiltered,
        [NAV_LEVELS.MAIN]: closeEPG,
        [NAV_LEVELS.CLOSED]: exitApp,
    }), [closeSidePanel, closeFiltered, closeTerms, closeConfirmDialog, closeEPG, exitApp]);

    // Execute callback
    const goBack = useCallback(() => {
        const handler = levelHandlers[currentLevel];
        if (handler) {
            handler();
        }
    }, [levelHandlers, currentLevel]);

    return {
        goBack,
        currentLevel,
    };
}
